export default __webpack_public_path__ + "static/media/interpreting_carousel_1.453480d8.jpg";